export default "__VITE_ASSET__37c6e55e__"